/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAuthType } from './ControlAuthType';
import {
    ControlAuthTypeFromJSON,
    ControlAuthTypeFromJSONTyped,
    ControlAuthTypeToJSON,
} from './ControlAuthType';
import type { ControlIntegrationActionV2 } from './ControlIntegrationActionV2';
import {
    ControlIntegrationActionV2FromJSON,
    ControlIntegrationActionV2FromJSONTyped,
    ControlIntegrationActionV2ToJSON,
} from './ControlIntegrationActionV2';
import type { ControlIntegrationMetadataConfigCustomFieldV2 } from './ControlIntegrationMetadataConfigCustomFieldV2';
import {
    ControlIntegrationMetadataConfigCustomFieldV2FromJSON,
    ControlIntegrationMetadataConfigCustomFieldV2FromJSONTyped,
    ControlIntegrationMetadataConfigCustomFieldV2ToJSON,
} from './ControlIntegrationMetadataConfigCustomFieldV2';
import type { ControlIntegrationType } from './ControlIntegrationType';
import {
    ControlIntegrationTypeFromJSON,
    ControlIntegrationTypeFromJSONTyped,
    ControlIntegrationTypeToJSON,
} from './ControlIntegrationType';
import type { ControlUseCase } from './ControlUseCase';
import {
    ControlUseCaseFromJSON,
    ControlUseCaseFromJSONTyped,
    ControlUseCaseToJSON,
} from './ControlUseCase';

/**
 * 
 * @export
 * @interface ControlIntegrationMetadataConfigV2
 */
export interface ControlIntegrationMetadataConfigV2 {
    /**
     * 
     * @type {ControlAuthType}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    authType: ControlAuthType;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    beta: boolean;
    /**
     * 
     * @type {Array<ControlIntegrationMetadataConfigCustomFieldV2>}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    customFields: Array<ControlIntegrationMetadataConfigCustomFieldV2>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    _default: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    docsUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    hideFromCatalog?: boolean;
    /**
     * 
     * @type {Array<ControlIntegrationType>}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    integrationTypes?: Array<ControlIntegrationType>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    internalCreds: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    logo: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    logoDark: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    logoLight: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    oauthRequiresRedirect?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    requiresConfiguration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    requiresWebhook?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    rtfm: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    singleInstallOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    statusUrl?: string;
    /**
     * 
     * @type {Array<ControlUseCase>}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    useCases: Array<ControlUseCase>;
    /**
     * 
     * @type {Array<ControlIntegrationActionV2>}
     * @memberof ControlIntegrationMetadataConfigV2
     */
    webhookActions: Array<ControlIntegrationActionV2>;
}

/**
 * Check if a given object implements the ControlIntegrationMetadataConfigV2 interface.
 */
export function instanceOfControlIntegrationMetadataConfigV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "authType" in value;
    isInstance = isInstance && "beta" in value;
    isInstance = isInstance && "customFields" in value;
    isInstance = isInstance && "_default" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "docsUrl" in value;
    isInstance = isInstance && "internalCreds" in value;
    isInstance = isInstance && "logo" in value;
    isInstance = isInstance && "logoDark" in value;
    isInstance = isInstance && "logoLight" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "rtfm" in value;
    isInstance = isInstance && "singleInstallOnly" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "useCases" in value;
    isInstance = isInstance && "webhookActions" in value;

    return isInstance;
}

export function ControlIntegrationMetadataConfigV2FromJSON(json: any): ControlIntegrationMetadataConfigV2 {
    return ControlIntegrationMetadataConfigV2FromJSONTyped(json, false);
}

export function ControlIntegrationMetadataConfigV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationMetadataConfigV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authType': ControlAuthTypeFromJSON(json['authType']),
        'beta': json['beta'],
        'customFields': ((json['customFields'] as Array<any>).map(ControlIntegrationMetadataConfigCustomFieldV2FromJSON)),
        '_default': json['default'],
        'description': json['description'],
        'docsUrl': json['docsUrl'],
        'hideFromCatalog': !exists(json, 'hideFromCatalog') ? undefined : json['hideFromCatalog'],
        'integrationTypes': !exists(json, 'integrationTypes') ? undefined : ((json['integrationTypes'] as Array<any>).map(ControlIntegrationTypeFromJSON)),
        'internalCreds': json['internalCreds'],
        'logo': json['logo'],
        'logoDark': json['logoDark'],
        'logoLight': json['logoLight'],
        'name': json['name'],
        'oauthRequiresRedirect': !exists(json, 'oauthRequiresRedirect') ? undefined : json['oauthRequiresRedirect'],
        'requiresConfiguration': !exists(json, 'requiresConfiguration') ? undefined : json['requiresConfiguration'],
        'requiresWebhook': !exists(json, 'requiresWebhook') ? undefined : json['requiresWebhook'],
        'rtfm': json['rtfm'],
        'singleInstallOnly': json['singleInstallOnly'],
        'slug': json['slug'],
        'statusUrl': !exists(json, 'statusUrl') ? undefined : json['statusUrl'],
        'useCases': ((json['useCases'] as Array<any>).map(ControlUseCaseFromJSON)),
        'webhookActions': ((json['webhookActions'] as Array<any>).map(ControlIntegrationActionV2FromJSON)),
    };
}

export function ControlIntegrationMetadataConfigV2ToJSON(value?: ControlIntegrationMetadataConfigV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authType': ControlAuthTypeToJSON(value.authType),
        'beta': value.beta,
        'customFields': ((value.customFields as Array<any>).map(ControlIntegrationMetadataConfigCustomFieldV2ToJSON)),
        'default': value._default,
        'description': value.description,
        'docsUrl': value.docsUrl,
        'hideFromCatalog': value.hideFromCatalog,
        'integrationTypes': value.integrationTypes === undefined ? undefined : ((value.integrationTypes as Array<any>).map(ControlIntegrationTypeToJSON)),
        'internalCreds': value.internalCreds,
        'logo': value.logo,
        'logoDark': value.logoDark,
        'logoLight': value.logoLight,
        'name': value.name,
        'oauthRequiresRedirect': value.oauthRequiresRedirect,
        'requiresConfiguration': value.requiresConfiguration,
        'requiresWebhook': value.requiresWebhook,
        'rtfm': value.rtfm,
        'singleInstallOnly': value.singleInstallOnly,
        'slug': value.slug,
        'statusUrl': value.statusUrl,
        'useCases': ((value.useCases as Array<any>).map(ControlUseCaseToJSON)),
        'webhookActions': ((value.webhookActions as Array<any>).map(ControlIntegrationActionV2ToJSON)),
    };
}

